import List from './list.vue';
import Edit from './edit.vue';

export default {
  List,
  Edit,
};
